import { d, removeQueryParams, w } from '@tinkoff/statist-page-data';
import { parseUrl } from '@tinkoff/statist-page-data/browser';
import path from '@tinkoff/utils/object/path';
var ReferrerResolver = /** @class */ (function () {
    function ReferrerResolver() {
        var _this = this;
        this.currentUrl = null;
        this.previousUrl = null;
        this.isPageReloaded = null;
        this.updateLocation = function () {
            var currentLocation = parseUrl(_this.currentUrl);
            if (w.location.hostname === currentLocation.hostname &&
                w.location.pathname === currentLocation.pathname) {
                return;
            }
            _this.isPageReloaded = false; // Если выполнение программы дошло сюда, значит произошла SPA-навигация
            _this.previousUrl = _this.currentUrl;
            _this.currentUrl = w.location.href;
        };
        this.runListeners = function () {
            var _a;
            (_a = w._statistLocationChangeListeners) === null || _a === void 0 ? void 0 : _a.forEach(function (fn) { return fn(); });
        };
        this.init();
    }
    /**
     * Подписывается на события, чтобы определить referrer при SPA переходах.
     * Вариант с переопределением pushState и событием popstate - стандартный способ из коробки.
     * Но он может не работать в некоторых framework'ах (e.g. tramvai).
     * Для этого случая используется событие '_statist-location-change', которое требуется dispatch'ить снаружи.
     */
    ReferrerResolver.prototype.init = function () {
        var _this = this;
        this.initLocation();
        window.addEventListener('_statist-location-change', function () {
            _this.updateLocation();
        });
        this.subscribeHistory();
    };
    ReferrerResolver.prototype.resolve = function () {
        var currentLocation = parseUrl(w.location.href);
        var referrerLocation = this.previousUrl ? parseUrl(this.previousUrl) : undefined;
        var previousLocation = this.isPageReloaded ? currentLocation : referrerLocation;
        if (!previousLocation) {
            return;
        }
        return removeQueryParams(previousLocation.href);
    };
    ReferrerResolver.prototype.initLocation = function () {
        this.previousUrl = d.referrer;
        this.currentUrl = w.location.href;
        this.isPageReloaded = path(['performance', 'navigation', 'type'], w) === 1;
    };
    /**
     * Подписывается на history.pushState (фактически переопределяет функцию) и событие popstate.
     * Даже если на странице несколько statist клиентов, то переопределяем pushState только один раз -
     *  когда нет сохраненных listeners
     */
    ReferrerResolver.prototype.subscribeHistory = function () {
        var _this = this;
        var _a;
        var supportsHtml5History = Boolean(typeof window !== 'undefined' && ((_a = window.history) === null || _a === void 0 ? void 0 : _a.pushState));
        if (!supportsHtml5History) {
            return;
        }
        if (Array.isArray(w._statistLocationChangeListeners)) {
            w._statistLocationChangeListeners.push(this.updateLocation);
            return;
        }
        w._statistLocationChangeListeners = [this.updateLocation];
        var originalPushState = window.history.pushState;
        window.history.pushState = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            setTimeout(_this.runListeners);
            originalPushState.apply(window.history, args);
        };
        window.addEventListener('popstate', function () {
            setTimeout(_this.runListeners);
        });
    };
    return ReferrerResolver;
}());
export { ReferrerResolver };
//# sourceMappingURL=referrer.js.map